export abstract class FormUtils {
  static isAllFieldsEmpty(formData: Record<string, any>): boolean {
    if (this.isNullOrUndefined(formData)) {
      return true;
    }

    if (typeof formData !== 'object') {
      return false;
    }

    const keys = FormUtils.filterUnwantedKeys(formData, ['submit']);

    if (keys.length === 0) {
      return true;
    }

    return keys.every((key: any) => this.isEmptyValue(formData[key]));
  }

  static isEmptyValue(value: any): boolean {
    if (this.isNullOrUndefined(value)) {
      return true;
    }

    if (typeof value === 'string') {
      return this.isEmptyString(value);
    }

    if (typeof value === 'boolean') {
      return this.isEmptyBoolean(value);
    }

    if (Array.isArray(value)) {
      return this.isEmptyArray(value);
    }

    if (typeof value === 'object') {
      return this.isEmptyObject(value);
    }

    if (typeof value === 'number') {
      return this.isEmptyNumber(value);
    }

    return false;
  }

  private static isNullOrUndefined(value: any): boolean {
    return value === null || value === undefined;
  }

  private static isEmptyString(value: string): boolean {
    const trimmed = value.trim();

    if (trimmed.length === 0) {
      return true;
    }

    // Default/empty date patterns like "00/00/0000"
    if (/^[0\/]+$/.test(trimmed)) {
      return true;
    }

    // Empty HTML content like "<p><br></p>" or "<p></p>"
    return /<p>(\s*|<br>|\s*<br>\s*)<\/p>/.test(trimmed);
  }

  private static isEmptyBoolean(value: boolean): boolean {
    return value === undefined || value === null;
  }

  private static isEmptyArray(value: any[]): boolean {
    if (value.length === 0) {
      return true;
    }

    return value.every(item => {
      if (typeof item === 'object') {
        return this.isEmptyObject(item);
      }
      return this.isEmptyValue(item);
    });
  }

  private static isEmptyObject(value: object): boolean {
    if (Object.keys(value).length === 0) {
      return true;
    }

    const hasSelectedValue = Object.values(value).some(content =>
      content === true || (typeof content === 'string' && content.trim().length > 0)
    );

    return !hasSelectedValue;
  }

  private static isEmptyNumber(value: number): boolean {
    return isNaN(value);
  }

  private static filterUnwantedKeys(formData: Record<string, any>, keys: string[]): Record<string, any> {
    return Object.keys(formData).filter(key => !keys.includes(key));
  }
}
